/**
 * This file was auto-generated.
 * Do not make direct changes to the file.
 */
/* eslint-disable @typescript-eslint/no-unused-vars */

import { z } from 'zod'

import * as CommonTypes from './common-types'

export const GiftCardStatus = {
	Active: 'ACTIVE',
	Inactive: 'INACTIVE',
	Reserved: 'RESERVED',
	Redeemed: 'REDEEMED'
} as const
export type GiftCardStatusType = (typeof GiftCardStatus)[keyof typeof GiftCardStatus]
export type GiftCard = {
	uuid: string
	name: string
	code: string
	amount: CommonTypes.Amount
	currencyCode: string
	status: GiftCardStatusType
	createdAt: number
	updatedAt: number
}
export const GiftCardRedemptionStatus = {
	Pending: 'PENDING',
	Applied: 'APPLIED'
} as const
export type GiftCardRedemptionStatusType = (typeof GiftCardRedemptionStatus)[keyof typeof GiftCardRedemptionStatus]

export const zGiftCardStatus = z.enum(['ACTIVE', 'INACTIVE', 'RESERVED', 'REDEEMED'])
export const zGiftCard = z.object({
	uuid: z.string(),
	name: z.string(),
	code: z.string(),
	amount: CommonTypes.zAmount,
	currencyCode: z.string(),
	status: zGiftCardStatus,
	createdAt: z.number(),
	updatedAt: z.number()
})
export const zGiftCardRedemptionStatus = z.enum(['PENDING', 'APPLIED'])
